// A crop of the car-park plan around one bay (the tenancy card and the resident's "Your parking").
import { useStoredImage } from '../../lib/parking';

export function PlanSnippet({ imageUrl, widthPx, heightPx, box, code, className = '' }: {
  imageUrl: string | null; widthPx: number | null; heightPx: number | null;
  box: { x: number | null; y: number | null; w: number | null; h: number | null }; code: string; className?: string;
}) {
  const img = useStoredImage(imageUrl);
  if (box.x === null || box.y === null || box.w === null || box.h === null) return null;
  const W = widthPx ?? 1600; const H = heightPx ?? 1000;
  // A window about three bays wide around the bay, 2:1, kept inside the plan.
  const winW = Math.min(100, Math.max(box.w * 5, 24));
  const winH = Math.min(100, (winW * W) / 2 / H);
  const cx = box.x + box.w / 2; const cy = box.y + box.h / 2;
  const winX = Math.max(0, Math.min(100 - winW, cx - winW / 2));
  const winY = Math.max(0, Math.min(100 - winH, cy - winH / 2));
  return (
    <div className={`relative w-full overflow-hidden rounded-xl border border-ink-100 bg-ink-50 ${className}`} style={{ aspectRatio: `${winW * W} / ${winH * H}` }} aria-label={`Bay ${code} on the car park plan`}>
      <div className="absolute" style={{ width: `${(100 * 100) / winW}%`, height: `${(100 * 100) / winH}%`, left: `${(-winX * 100) / winW}%`, top: `${(-winY * 100) / winH}%` }}>
        {img.src && <img src={img.src} alt="" className="absolute inset-0 h-full w-full select-none" draggable={false} />}
        <div className="absolute grid place-items-center rounded-[3px] border-[3px] border-bronze-600 bg-bronze-500/40 text-[12px] font-bold text-on-primary shadow-[0_0_0_4px_rgba(44,106,216,0.25)]"
          style={{ left: `${box.x}%`, top: `${box.y}%`, width: `${box.w}%`, height: `${box.h}%` }}>{code}</div>
      </div>
    </div>
  );
}
